import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import configureStore from './store'
import * as Sentry from "@sentry/react";
import * as serviceWorker from './serviceWorker';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSL,
    environment: import.meta.env.VITE_ENV,
    autoSessionTracking: true,
    integrations: [
        Sentry.browserTracingIntegration(),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.2,
});

// Suppress warnings in staging and production environments
// Leave warnings enabled in development, where they can be useful for debugging
const isNonDevEnv = ['staging', 'production'].includes(import.meta.env.VITE_ENV);
if (isNonDevEnv) {
  console.warn = () => {};
}

ReactDOM.render(<App store={ configureStore() } />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
